import type { IModeloDispositivo } from 'modelos';

import type { OpcionBuscable } from '@ui/filtros/selector-buscable.component';

type MarcaYModelo = Pick<IModeloDispositivo, 'marca' | 'modelo'>;

/**
 * Marca y modelo en una línea («Philips EVO 40»), para donde no entran dos: el
 * disparador de un selector, una celda. `undefined` si no tiene ninguno.
 */
export function nombreModelo(m: MarcaYModelo | undefined): string | undefined {
  if (!m) return undefined;
  return [m.marca?.trim(), m.modelo?.trim()].filter(Boolean).join(' ') || undefined;
}

/**
 * Cómo se lee un modelo en una sugerencia: el modelo arriba, como título, y la
 * marca abajo, en el texto secundario.
 *
 * Es el mismo reparto en todos los buscadores (el del listado, el global y los
 * selectores de filtro): puestos en una sola línea no se distinguía dónde
 * terminaba la marca y empezaba el modelo.
 */
export function lineasModelo(m: MarcaYModelo): { titulo: string; detalle: string } {
  return {
    titulo: m.modelo?.trim() || 'Sin modelo',
    detalle: m.marca?.trim() || 'Sin marca',
  };
}

/** Un modelo como opción de un selector buscable, con las dos líneas de {@link lineasModelo}. */
export function opcionModelo(m: MarcaYModelo & { _id?: string }): OpcionBuscable {
  const { titulo, detalle } = lineasModelo(m);
  return {
    valor: m._id!,
    etiqueta: titulo,
    detalle,
    // Elegido, el disparador dice las dos cosas juntas: es lo mismo que después
    // trae el nombre buscado por id, y así no cambia al llegar.
    nombreElegido: nombreModelo(m) ?? m._id!,
  };
}
